import { Controller } from "@hotwired/stimulus"
import Coloris from "@melloware/coloris";

// Connects to data-controller="coloris"
export default class extends Controller {
  connect() {
    Coloris.init()
    Coloris({
      el: this.element,
      swatches: [
        '#264653',
        '#2a9d8f',
        '#e9c46a',
        'rgb(244,162,97)',
        '#e76f51',
        '#d62828',
        'navy',
        '#07b',
        '#0096c7',
        '#00b4d880',
        'rgba(0,119,182,0.8)'
      ],
      themeMode: this.getPreferredColorScheme()
    })
  }
  getPreferredColorScheme() {
    if (window.matchMedia) {
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
      } else {
        return 'light';
      }
    }
    return 'light';
  }
}
